import { AUTH_BASE_URL, AUTH_CLIENT_ID } from "./utils/env.config";

const AUTH_ISSUER = AUTH_BASE_URL;
const REDIRECT_URI = `${window.location.origin}/login/callback`;

export const IDLE_MS = 15 * 60 * 1000;
export const WARN_MS = 60 * 1000;

export default {
  oidc: {
    clientId: AUTH_CLIENT_ID,
    issuer: AUTH_ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ["openid", "profile", "email"],
    pkce: true,
    disableHttpsCheck: false,
  },
};
